<template>
    <vx-card no-shadow card-border>
        <div class="flex flex-wrap items-center mb-base">
            <vs-avatar :src="imagenUsuario" size="110px" class="mb-4 mr-4" />
            <div>
                <vs-button 
                    icon-pack="feather" 
                    icon="icon-refresh-cw" 
                    color="rgb(62, 201, 214)" 
                    class="mr-4 mt-base sm:mb-0 vs-con-loading__container"
                    id="button-update-photo-with-loading"
                    @click="actualizarFoto"
                >
                    Actualizar foto
                </vs-button>
            </div>
        </div>

        <vs-input class="w-full mb-4 md:w-1/4" readonly label="Usuario" v-validate="'required'" name="usuario" v-model="inputUsuario"></vs-input>
        <span class="text-sm text-danger" v-show="errors.has('usuario')">{{ errors.first('usuario') }}</span>

        <div class="vx-row">
            <div class="w-full mb-4 vx-col md:w-1/2">
                <vs-input class="w-full" v-model="inputApellidos" label="Apellidos" v-validate="''" name="apellidos" placeholder="Apellidos"/>
                <span class="text-sm text-danger" v-show="errors.has('apellidos')">{{ errors.first('apellidos') }}</span>
            </div>
            <div class="w-full mb-4 vx-col md:w-1/2">                   
                <vs-input class="w-full" v-model="inputNombres" label="Nombres" v-validate="'required'" name="nombres" placeholder="Nombres"/>
                <span class="text-sm text-danger" v-show="errors.has('nombres')">{{ errors.first('nombres') }}</span>
            </div>
        </div>

        <div class="vx-row">
            <div class="w-full mb-4 vx-col md:w-1/2">
                <vs-input class="w-full" v-model="inputEmail" label="Correo" v-validate="'required|email'" name="correo" placeholder="Correo"/>
                <span class="text-sm text-danger" v-show="errors.has('correo')">{{ errors.first('correo') }}</span>
            </div>
            <div class="w-full mb-4 vx-col md:w-1/2">                   
                <vs-input class="w-full" v-model="inputTelefono" label="Telf. movil" v-validate="''" name="telefono" placeholder="Telf. Movil"/>
                <span class="text-sm text-danger" v-show="errors.has('telefono')">{{ errors.first('telefono') }}</span>
            </div>
        </div>

        <div class="vx-row">
            <div class="w-full mb-4 vx-col md:w-1/2">
                <vs-input class="w-full" v-model="inputOficina" readonly label="Oficina" v-validate="''" name="oficina" placeholder="Oficina y/o Unidad Orgánica"/>
                <span class="text-sm text-danger" v-show="errors.has('oficina')">{{ errors.first('oficina') }}</span>
            </div>
            <div class="w-full mb-4 vx-col md:w-1/2">                   
                <vs-input class="w-full" v-model="inputCargo" readonly label="Cargo" v-validate="''" name="cargo" placeholder="Cargo"/>
                <span class="text-sm text-danger" v-show="errors.has('cargo')">{{ errors.first('cargo') }}</span>
            </div>
        </div>

        <div class="vx-row">
            <div class="w-full mb-2 vx-col md:w-1/2">
                <vs-input class="w-full" v-model="inputProfesion" readonly label="Profesión" v-validate="''" name="categoria" placeholder="Profesión"/>
                <span class="text-sm text-danger" v-show="errors.has('categoria')">{{ errors.first('categoria') }}</span>
            </div>
            <div class="w-full mb-2 vx-col md:w-1/2">                   
                <vs-input class="w-full" v-model="inputCategoria" readonly label="Categoria" v-validate="''" name="categoria" placeholder="Categoria"/>
                <span class="text-sm text-danger" v-show="errors.has('categoria')">{{ errors.first('categoria') }}</span>
            </div>
        </div>

        <div class="flex flex-wrap items-center justify-end">
            <vs-button @click="guardar" class="mt-2 ml-auto" icon-pack="feather" icon="icon-save" :disabled="!validateForm">Guardar</vs-button>
            <vs-button @click="limpiar" class="mt-2 ml-4" icon-pack="feather" type="border" icon="icon-trash" color="warning">Limpiar</vs-button>
        </div>

    </vx-card>
</template>
<script>
export default {
    data () {
        return {
            inputUsuario    : null,
            inputApellidos  : null,
            inputNombres    : null,
            inputEmail      : null,
            inputTelefono   : null,
            inputOficina    : null,
            inputCargo      : null,
            inputProfesion  : null,
            inputCategoria  : null,

            imagenUsuario   : this.$store.state.AppActiveUser.photoURL,
            backgroundLoading   : 'primary',
            colorLoading        : '#fff',
        }
    },

    computed: {
        activeUserInfo () {
            return this.$store.state.AppActiveUser
        }
    },

    watch: {
        validateForm(){
            return !this.errors.any() 
            && this.inputUsuario  !== null 
            && this.inputNombres    !== null
            && this.inputEmail      !== null;
        }
    },

    mounted(){
        //this.obtenerPersona();
    },

    methods: {
        obtenerPersona(){
            this.$vs.loading();
            this.$http.perfilPersona()
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.cargarDatos(response.data);
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                if(error.response === undefined){
                    this.$vs.dialog({
                        type: 'alert',
                        color: 'warning',
                        title: `Aviso`,
                        text: 'Ocurrio un error al realizar la consulta.',
                        acceptText: 'Aceptar',
                        accept: this.regresar
                    });
                    return;
                }
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        actualizarFoto(){
            this.$vs.loading({
                background: 'rgb(62, 201, 214)',
                color: this.colorLoading,
                container: "#button-update-photo-with-loading",
                scale: 0.45
            });

            this.$http.actualizarFoto()
            .then(response => {
                this.$vs.loading.close("#button-update-photo-with-loading > .con-vs-loading")
                if(response.status === 200){
                    console.log(response.data);
                }
            })
            .catch(error => {
                this.$vs.loading.close("#button-update-photo-with-loading > .con-vs-loading")
                if(error.response === undefined){
                    this.$vs.dialog({
                        type: 'alert',
                        color: 'warning',
                        title: `Aviso`,
                        text: 'Ocurrio un error al realizar la consulta.',
                        acceptText: 'Aceptar',
                        accept: this.regresar
                    });
                    return;
                }
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        cargarDatos(data){
            this.inputUsuario    = data.numDocumento;
            this.inputApellidos  = data.apellidos;
            this.inputNombres    = data.nombres;
            this.inputEmail      = data.email;
            this.inputTelefono   = data.telefono;
            this.inputOficina    = data.oficina !== null ? data.oficina.descripcion : null;
            this.inputCargo      = data.cargo !== null ? data.cargo.descripcion : null;
            this.inputProfesion  = data.profesion;
            this.inputCategoria  = data.categoria;

            if(data.imagen !== null){
                let image = new Image();
                image.src = 'data:image/png;base64,' + data.imagen;
                this.imagenUsuario = image.src;
            }
        },

        guardar(){
            if(this.inputEmail === null || this.inputNombres === null){
                this.$vs.dialog({
                    type: 'alert',
                    color: 'warning',
                    title: `Aviso`,
                    text: 'Los campos son obligatorios',
                    acceptText: 'Aceptar',
                });
                return;
            }
            const payload = {
                id: this.inputUsuario,
                data: {
                    email: this.inputEmail.trim(),
                    nombres: this.inputNombres.trim().toUpperCase(),
                    apellidos: this.inputApellidos.trim().toUpperCase(),
                    telefono: this.inputTelefono.trim()
                }
            }

            this.$vs.loading();
            this.$http.actualizarPerfil(payload)
            .then(response => {
                this.$vs.loading.close()
                if(response.status === 200){
                    this.obtenerPersona();
                }
            })
            .catch(error => {
                this.$vs.loading.close()
                if(error.response === undefined){
                    this.$vs.dialog({
                        type: 'alert',
                        color: 'warning',
                        title: `Aviso`,
                        text: 'Ocurrio un error al realizar la consulta.',
                        acceptText: 'Aceptar',
                        accept: this.regresar
                    });
                    return;
                }
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        limpiar(){
            this.inputApellidos  = null;
            this.inputNombres    = null;
            this.inputEmail      = null;
            this.inputTelefono   = null;
        },

        showMessageAlert(message){
            this.$vs.notify({
                title: 'Aviso',
                text: message,
                position:'top-center',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        },

        showMessageSuccess(message){
            this.$vs.notify({
                title: 'Información',
                text: message,
                position:'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
            });
        },

        showMessageError(status, message){
            if(status === 400 || status === 409){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 401){
                this.popupRiesgo = false;
                this.popupEliminar = false;
                this.$store.dispatch("logout").then(() => {
                    this.$router.push('/login').catch(() => {})
                });
            }
            if(status === 403){
                this.popupRiesgo = false;
                this.popupEliminar = false;
                this.$vs.notify({
                    title: 'ACCESO DENEGADO',
                    text: 'No tiene permisos para esta proceso.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            if(status === 404){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 417){
                this.$vs.notify({
                    title: 'ALERTA',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            if(status === 500){
                this.$vs.notify({
                    title: 'ERROR',
                    text: 'Ups!!!. Ocurrio un error. Vuelve a intentarlo.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle',
                    color: 'danger'
                });
            }
        },
        
    }
}
</script>